import { render, staticRenderFns } from "./DashboardsModal.vue?vue&type=template&id=b3ecf500&"
import script from "./DashboardsModal.vue?vue&type=script&lang=js&"
export * from "./DashboardsModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardsModal.vue?vue&type=style&index=0&id=b3ecf500&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports